export class HealthGuidelineCategorization{
    public idHealthGuidelineCategorization: number;
    public categorizationName: string;
    public description: string;
    public idCareLinePriority: number;
    public isDeleted: boolean;
    public useDatetimeEpisode: boolean;
    public datetimeInclusion: Date;
    public idHealthGuideline: number;
}